interface Props {
  locked: boolean;
  onToggle: () => void;
  label?: string;
}

/**
 * Per-field lock toggle. Locked => hard constraint (must hold); unlocked =>
 * soft preference (generator may relax). Per design doc §"Constraint controls".
 *
 * Uses a unicode padlock glyph (🔒 / 🔓) and relies on the `on` class to
 * switch the filled/hollow look instead of rendering the text "LOCK".
 */
export function LockToggle({ locked, onToggle, label = 'Lock' }: Props) {
  return (
    <button
      type="button"
      className={`lock-toggle${locked ? ' on' : ''}`}
      onClick={onToggle}
      aria-pressed={locked}
      aria-label={`${label}: ${locked ? 'locked (hard constraint)' : 'unlocked (soft preference)'}`}
      title={
        locked
          ? 'Locked — hard constraint. Click to unlock (soft preference).'
          : 'Unlocked — soft preference. Click to lock (hard constraint).'
      }
    >
      <span aria-hidden="true" className="lock-toggle-glyph">
        {locked ? '\u{1F512}' : '\u{1F513}'}
      </span>
    </button>
  );
}
